import * as React from "react";
import { AuthConsumer } from "../../components/AuthProvider";
import LoginForm from "./LoginForm";

export interface Props {
  children?: React.ReactNode;
}

export interface State {}

export default class LoginPage extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <AuthConsumer>
        {auth => (
          <LoginForm onLogin={(token: string) => auth.setToken(token)} />
        )}
      </AuthConsumer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/Login/LoginPage.tsx